<template>
<div class="groupSet card">
    <h4 class="group-title">WordPress</h4>
    <p class="description">The eCheckpoint plugin for WordPress can be installed from the WordPress Plugin Store</p>
    <a href="https://wordpress.com/plugins/echeckpoint" target="_blank" class="btn userButton btn-primary">Download Plugin</a>
</div>
</template>

<script>

export default {
        page: {
        title: "WordPress Plugin",
    },
}
</script>

<style lang="scss" scoped>
a
{
    margin-left: auto;
    margin-right: auto;
    width: 50% !important;
}
</style>